<template>
  <div class="md-layout" style="align-items: center">
    <div v-if="field.fieldType == 'spacer'" v-html="field.value" :style="{ height: getHeight(field.height) }"></div>

    <div v-else-if="field.fieldType == 'static-text'" v-html="field.value" class="md-layout-item"></div>

    <div v-else-if="field.fieldType == 'row' && field.children && field.children.length" style="display: flex; width: 100%" :style="{ gridTemplateColumns: field.children.map(m => '1fr').join(' ')}">
      <dynamic-form-item :style="{ flex: getFlexWidth(child.width) }" v-for="(child, i) in field.children" :field="child" :formData="formData" @change="onInput(...arguments)" :key="i" />
    </div>

    <template v-else>
      <div class="md-layout-item">
        <ValidationProvider
          :name="field.name"
          :rules="getRequiredValidation(field)"
          v-slot="{ passed, failed }"
        >
          <md-checkbox v-if="field.fieldType == 'checkbox'" :disabled="field.disabled" :value="true" :model="displayValue" @change="onInput(field.name, $event)" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
            {{ getTitleLabel(field) }}
            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
          </md-checkbox>

          <md-field v-else-if="field.fieldType == 'textfield' || field.fieldType == 'select'" :class="{ 'md-error': failed, 'md-valid': passed }">
            <label>{{ getTitleLabel(field) }}</label>
            <md-input v-if="field.fieldType == 'textfield'" :value="displayValue" @input="onInput(field.name, $event)" style="width: 0" :disabled="field.disabled"></md-input>

            <md-select v-else-if="field.fieldType == 'select'" :value="displayValue" @input="onInput(field.name, $event)" style="width: 0" :disabled="field.disabled">
              <md-option v-for="(option, index) in field.options"
              :key="index" :value="option.value">{{ getSelectOption(option) }}</md-option>
            </md-select>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>
      </div>
      <label v-if="field.help" class="md-layout-item" style="flex: 0 0 26px">
        <md-icon>
          <md-tooltip md-direction="top">{{ field.help }}</md-tooltip>
          help
        </md-icon>
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: "dynamic-form-item",
  props: ["field", "formData", "topLabel"],
  computed: {
    displayValue() {
      if (this.field.fieldType === 'checkbox') {
        return !!this.formData[this.field.name];
      } else {
        return this.formData[this.field.name];
      }
    }
  },
  watch: {
    displayValue: function(newValue) {
      this.$emit('change', this.field.name, newValue);
    }
  },
  methods: {
    onInput(fieldName, value) {
      this.$emit('change', fieldName, value);
    },
    getHeight(height) {
      if (height == null) {
        return 0;
      }
      if (typeof height === 'string' && height.trim().endsWith('px')) {
        return height;
      }
      return height + 'px';
    },
    getFlexWidth(width) {
      if (width == null) {
        return '1 1';
      }
      if (typeof width === 'string' && width.trim().endsWith('px')) {
        return '0 0 ' + width;
      }
      return width + ' 1';
    },
    getSelectOption(option) {
      if(option.display == null) {
        return option.value
      } else {
        return option.display
      }
    },
    getTitleLabel(field) {
      if(field.required) {
        return field.title + "*";
      } else {
        return field.title;
      }
    },
    getRequiredValidation(field) {
      if(field.name == "email") {
        return "email";
      } else {
        if(field.required != null && field.required) {
          if (field.fieldType === 'checkbox') {
            return { required: { allowFalse: false } };
          }
          return "required";
        }
      }
      return "";
    },
  }
}
</script>


<style lang="css" scoped>
  .md-field .md-select~.md-icon {
    right: 25px;
  }
  .md-checkbox.md-error .md-icon {
    color: #f44336;
  }
</style>
